module.exports = __webpack_public_path__ + "static/media/cafe24-taxrefund.0e53889b.png";